import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";
import Loader from "../components/Loader";
import ViewModal from "../components/ViewModal";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const apiKey = process.env.REACT_APP_API_KEY;

export default function BrandContactDetails() {
  const { country } = useParams();
  const isAdmin = Cookies.get("user_role") === "Administrator";
  const headers = { Authorization: apiKey, "Content-Type": "application/json" };

  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState({
    brandName: "",
    website: "",
    phoneNumber: "",
    details: "",
  });
  const [viewOpen, setViewOpen] = useState(false);
  const [selected, setSelected] = useState(null);

  const loadItems = () => {
    setLoading(true);
    axios
      .get(`${BASE_URL}/getbrandcontacts/${encodeURIComponent(country)}`, { headers })
      .then((res) => {
        setItems(res.data || []);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    loadItems();
  }, [country]);

  const resetForm = () => {
    setEditingId(null);
    setForm({ brandName: "", website: "", phoneNumber: "", details: "" });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      Country: country,
      BrandName: form.brandName.trim(),
      Website: form.website.trim(),
      PhoneNumber: form.phoneNumber.trim(),
      Details: form.details.trim(),
    };
    if (!payload.BrandName || !payload.Website || !payload.PhoneNumber || !payload.Details) {
      alert("All fields required.");
      return;
    }
    if (editingId) {
      axios
        .put(`${BASE_URL}/updatebrandcontact`, { ...payload, Id: editingId }, { headers })
        .then(() => {
          resetForm();
          loadItems();
        })
        .catch((error) => console.log(error));
      return;
    }

    axios
      .post(`${BASE_URL}/addbrandcontact`, payload, { headers })
      .then(() => {
        resetForm();
        loadItems();
      })
      .catch((error) => console.log(error));
  };

  const deleteItem = (id) => {
    if (!window.confirm("Delete this brand contact?")) return;
    axios
      .delete(`${BASE_URL}/deletebrandcontact/${id}`, { headers })
      .then(() => {
        if (editingId === id) resetForm();
        loadItems();
      })
      .catch((error) => console.log(error));
  };

  const copyItem = async (item) => {
    const text = `Brand: ${item.BrandName}\nWebsite: ${item.Website}\nPhone: ${item.PhoneNumber}\nDetails: ${item.Details}`;
    try {
      await navigator.clipboard.writeText(text);
      alert("Copied.");
    } catch (error) {
      console.log(error);
    }
  };

  if (loading) return <Loader />;

  return (
    <div className="container">
      <h2>{country} - Brand Contact Details</h2>
      <br />
      {isAdmin && (
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-sm-3">
              <input
                className="form-control"
                placeholder="Brand Name"
                value={form.brandName}
                onChange={(e) => setForm({ ...form, brandName: e.target.value })}
              />
            </div>
            <div className="col-sm-3">
              <input
                className="form-control"
                placeholder="Website"
                value={form.website}
                onChange={(e) => setForm({ ...form, website: e.target.value })}
              />
            </div>
            <div className="col-sm-2">
              <input
                className="form-control"
                placeholder="Phone Number"
                value={form.phoneNumber}
                onChange={(e) => setForm({ ...form, phoneNumber: e.target.value })}
              />
            </div>
            <div className="col-sm-4">
              <textarea
                className="form-control"
                rows="2"
                placeholder="Details"
                value={form.details}
                onChange={(e) => setForm({ ...form, details: e.target.value })}
              />
            </div>
          </div>
          <br />
          <button className="btn btn-primary" type="submit">
            {editingId ? "Update" : "Add"}
          </button>
          {editingId && (
            <button className="btn btn-secondary ms-2" type="button" onClick={resetForm}>
              Cancel
            </button>
          )}
          <br />
          <br />
        </form>
      )}

      <table className="table table-striped table-dark crm-table">
        <thead>
          <tr>
            <th>Brand</th>
            <th>Website</th>
            <th>Phone</th>
            <th>Details</th>
            <th className="crm-col-actions">View</th>
            <th className="crm-col-actions">Copy</th>
            {isAdmin && (
              <>
                <th className="crm-col-actions">Edit</th>
                <th className="crm-col-actions">Delete</th>
              </>
            )}
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.Id}>
              <td>{item.BrandName}</td>
              <td style={{ maxWidth: "240px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {item.Website}
              </td>
              <td>{item.PhoneNumber}</td>
              <td className="crm-cell-box" style={{ maxWidth: "360px" }}>
                <div className="crm-preview" style={{ whiteSpace: "pre-wrap" }}>
                  {item.Details}
                </div>
              </td>
              <td className="crm-col-actions">
                <button
                  className="btn btn-sm btn-light crm-icon-btn"
                  onClick={() => {
                    setSelected(item);
                    setViewOpen(true);
                  }}
                  title="View"
                >
                  <i className="bi bi-eye"></i>
                </button>
              </td>
              <td className="crm-col-actions">
                <button className="btn btn-sm btn-info crm-icon-btn" onClick={() => copyItem(item)} title="Copy">
                  <i className="bi bi-clipboard"></i>
                </button>
              </td>
              {isAdmin && (
                <>
                  <td className="crm-col-actions">
                    <button className="btn btn-sm btn-light crm-icon-btn" onClick={() => {
                      setEditingId(item.Id);
                      setForm({
                        brandName: item.BrandName,
                        website: item.Website,
                        phoneNumber: item.PhoneNumber,
                        details: item.Details,
                      });
                    }} title="Edit">
                      <i className="bi bi-pencil-square"></i>
                    </button>
                  </td>
                  <td className="crm-col-actions">
                    <button className="btn btn-sm btn-danger crm-icon-btn" onClick={() => deleteItem(item.Id)} title="Delete">
                      <i className="bi bi-trash3"></i>
                    </button>
                  </td>
                </>
              )}
            </tr>
          ))}
          {items.length === 0 && (
            <tr>
              <td colSpan={isAdmin ? 8 : 6} className="text-center">No records found.</td>
            </tr>
          )}
        </tbody>
      </table>

      <ViewModal
        open={viewOpen}
        title={selected ? `Brand Contact - ${selected.BrandName}` : "Brand Contact"}
        onClose={() => setViewOpen(false)}
      >
        {selected && (
          <div className="p-2">
            <div className="mb-3">
              <div className="text-muted">
                <strong>Country:</strong> {country}
              </div>
            </div>
            <div className="row g-3">
              <div className="col-md-6">
                <div className="p-3" style={{ border: "1px solid #e5e5e5", borderRadius: "10px" }}>
                  <div><strong>Brand:</strong> {selected.BrandName}</div>
                  <div><strong>Website:</strong> {selected.Website}</div>
                  <div><strong>Phone:</strong> {selected.PhoneNumber}</div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="p-3" style={{ border: "1px solid #e5e5e5", borderRadius: "10px", whiteSpace: "pre-wrap" }}>
                  <div style={{ marginBottom: "6px" }}><strong>Details</strong></div>
                  {selected.Details}
                </div>
              </div>
            </div>
          </div>
        )}
      </ViewModal>
    </div>
  );
}
